import Router from 'next/router'

const toUrl = href => {
  if (typeof window === 'undefined') return null
  if (typeof href !== 'string') return null

  try {
    return new URL(href, window.location.origin)
  } catch {
    return null
  }
}

/**
 * Dashboard 内部页面统一走 Next Router；跨站目标保留浏览器导航能力。
 * 禁止业务代码直接写 location.href，避免同站切换触发整页重新初始化。
 */
export const navigateTo = href => {
  const target = toUrl(href)

  if (!target || target.origin === window.location.origin) {
    const path = target ? `${target.pathname}${target.search}${target.hash}` : href

    return Router.push(path)
  }

  window.open(href, '_self')

  return Promise.resolve(true)
}

export const replaceWith = href => {
  const target = toUrl(href)

  if (!target || target.origin === window.location.origin) {
    const path = target ? `${target.pathname}${target.search}${target.hash}` : href

    return Router.replace(path)
  }

  window.open(href, '_self')

  return Promise.resolve(true)
}

export const openInNewTab = href => window.open(href, '_blank', 'noopener,noreferrer')
